export default {
  'coupon.h1': 'USFans Coupon & Discount Code Guide 2026',
  'coupon.lead': 'Learn how USFans coupons and discount codes work, where to look for promotions, and how to make sure you get the best value on your order.',
  'coupon.category': 'Coupons',
  'coupon.shortTitle': 'USFans Coupon Guide',
  'coupon.readTime': '6 min read',
  'coupon.toc': 'Table of Contents',

  'coupon.s1.title': 'How Coupons Work',
  'coupon.s1.p1': 'A coupon or discount code is a short code you enter at checkout to reduce the price of your order. Coupons can take different forms — such as a percentage off, a fixed amount off, or free shipping on qualifying orders.',
  'coupon.s1.p2': 'On most online stores, including USFans, the code is applied during checkout before you complete payment, so you can see the adjusted total before confirming the order.',

  'coupon.s2.title': 'Where to Find Promotions',
  'coupon.s2.p1': 'Promotions are often announced on the store\'s own website, in its newsletter, or through seasonal sales events. Checking the store around major shopping seasons or holidays can be a good time to find active deals.',
  'coupon.s2.p2': 'Because offers change frequently and are often time-limited, a code that worked yesterday may no longer be valid today. Always check the current promotion details directly on the store.',

  'coupon.s3.title': 'Types of Discounts',
  'coupon.s3.p1': 'Percentage discounts reduce the total by a fixed percentage, while fixed-amount discounts subtract a set value from the order. Some codes offer free shipping, and others may only apply to specific categories or a minimum order amount.',
  'coupon.s3.p2': 'Reading the terms of each offer is important, because a code that looks generous may have conditions — such as a minimum spend or exclusions on certain items.',

  'coupon.s4.title': 'Getting the Best Value',
  'coupon.s4.p1': 'To get the best value, compare a few things: the discount itself, any minimum spend requirement, and whether the item you want is included. Sometimes a smaller discount with no minimum is actually better than a larger one with strict conditions.',
  'coupon.s4.p2': 'It also helps to check whether the discount stacks with shipping or other offers. In many cases, only one code can be used per order, so choose the one that saves you the most.',

  'coupon.s5.title': 'Discount Types Compared',
  'coupon.s5.p1': 'The table below compares common coupon types to help you understand which one suits your order.',
  'coupon.table.c1': 'Type',
  'coupon.table.c2': 'How it works',
  'coupon.table.c3': 'Good to know',
  'coupon.table.c4': 'Best for',
  'coupon.table.r1c1': 'Percentage off',
  'coupon.table.r1c2': 'Reduces total by a %',
  'coupon.table.r1c3': 'Savings grow with order size',
  'coupon.table.r1c4': 'Larger orders',
  'coupon.table.r2c1': 'Fixed amount',
  'coupon.table.r2c2': 'Subtracts a set value',
  'coupon.table.r2c3': 'May need minimum spend',
  'coupon.table.r2c4': 'Smaller orders',
  'coupon.table.r3c1': 'Free shipping',
  'coupon.table.r3c2': 'Removes shipping fee',
  'coupon.table.r3c3': 'Usually for qualifying orders',
  'coupon.table.r3c4': 'Saving on delivery',
  'coupon.table.r4c1': 'Category deal',
  'coupon.table.r4c2': 'Applies to specific items',
  'coupon.table.r4c3': 'Check which items qualify',
  'coupon.table.r4c4': 'Targeted shopping',

  'coupon.s6.title': 'Avoiding Expired Codes',
  'coupon.s6.p1': 'Expired or invalid codes are common. When a code does not work, it usually means the offer has ended, the code was entered incorrectly, or the order does not meet the conditions.',
  'coupon.s6.p2': 'The most reliable way to find a valid code is to check the official store directly, since that is where current promotions are listed accurately.',

  'coupon.s7.title': 'Staying Safe with Deals',
  'coupon.s7.p1': 'Be cautious of third-party sites promising unusually large discounts, as these can sometimes lead to expired or misleading offers. The safest source for a discount is the store\'s own website or official communication.',
  'coupon.s7.p2': 'Never share your payment or account details with any site in exchange for a code, and always complete your purchase on the official checkout page.',

  'coupon.conclusion.title': 'Summary',
  'coupon.conclusion.p1': 'USFans coupons and discount codes can lower your total, but their value depends on the terms and whether they apply to your order. Checking the official store is the best way to find active, valid offers.',
  'coupon.conclusion.p2': 'Ready to shop? Explore the categories on the homepage or head straight to the full store.',

  'coupon.cta': 'Browse USFans Deals',
  'coupon.backHome': 'Back to Homepage',
};